import { z } from 'zod';
import { CONTRACT_TYPES } from '@fortem-monorepo/constants';
export const contractTypeSchema = z.enum(CONTRACT_TYPES);
